export let AppConnectionStatuses;
(function (AppConnectionStatuses) {
  AppConnectionStatuses["CONNECTION_LOST"] = "connection_lost";
  AppConnectionStatuses["DISCONNECTED"] = "disconnected";
  AppConnectionStatuses["NEEDS_REAUTHORIZATION"] = "needs_reauthorization";
  AppConnectionStatuses["NEW_FEATURES_AVAILABLE"] = "new_features_available";
  AppConnectionStatuses["NO_STATUS_AVAILABLE"] = "no_status_available";
  AppConnectionStatuses["OK"] = "ok";
  AppConnectionStatuses["SYNC_ERROR"] = "sync_error";
  AppConnectionStatuses["SUNSET"] = "sunset";
  AppConnectionStatuses["UPCOMING_SUNSET"] = "upcoming_sunset";
  AppConnectionStatuses["UPDATE_AVAILABLE"] = "update_available";
  AppConnectionStatuses["UPGRADE_AVAILABLE"] = "upgrade_available";
})(AppConnectionStatuses || (AppConnectionStatuses = {}));
export const APP_CONNECTION_STATUSES_ICONS = {
  [AppConnectionStatuses.CONNECTION_LOST]: {
    illustrationName: 'caution-connect-shared-email'
  },
  [AppConnectionStatuses.DISCONNECTED]: {
    illustrationName: 'caution-connect-shared-email'
  },
  [AppConnectionStatuses.NEEDS_REAUTHORIZATION]: {
    illustrationName: 'caution-connect-shared-email'
  },
  [AppConnectionStatuses.SYNC_ERROR]: {
    illustrationName: 'caution-connect-shared-email'
  },
  [AppConnectionStatuses.NO_STATUS_AVAILABLE]: {
    illustrationName: 'empty-state-charts'
  },
  [AppConnectionStatuses.NEW_FEATURES_AVAILABLE]: {
    illustrationName: 'success-green'
  },
  [AppConnectionStatuses.OK]: {
    illustrationName: 'success-green'
  },
  [AppConnectionStatuses.SUNSET]: {
    illustrationName: 'integrations'
  },
  [AppConnectionStatuses.UPCOMING_SUNSET]: {
    illustrationName: 'integrations'
  },
  [AppConnectionStatuses.UPDATE_AVAILABLE]: {
    illustrationName: 'integrations'
  },
  [AppConnectionStatuses.UPGRADE_AVAILABLE]: {
    illustrationName: 'integrations'
  }
};